<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'padding: 12px; margin: 4px'
            : 'padding: 18px; margin: 18px'
        "
      >
        <v-row
          v-if="loading"
          class="fill-height ma-5 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="80"
            color="teal"
            indeterminate
          />
          <span style="font-size: 18px">Carregando...</span>
        </v-row>
        <div v-else>
          <v-row
            v-if="!loading"
            align="center"
            :justify="user.CodRole === 3 ? 'space-between' : 'start'"
          >
            <v-col
              v-if="user.CodRole === 3"
              class="pa-1"
              cols="12"
              sm="6"
              md="3"
            >
              <v-select
                v-model="agroindustria"
                :rules="[v => !!v || 'Obrigatório']"
                :items="agroindustrias"
                color="teal"
                item-text="display_nome"
                return-object
                label="Agroindústria"
                prepend-icon="mdi-factory"
                no-data-text="Sem agroindústrias"
                multiple
                required
              />
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataInicio).format('DD/MM/YYYY')"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    color="teal"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataInicio"
                  style="margin: 0px"
                  :max="dataFim"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataIni = false"
                />
              </v-menu>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataFim).format('DD/MM/YYYY')"
                    color="teal"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFim"
                  :min="dataInicio"
                  :max="dataLimite"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataFim = false"
                />
              </v-menu>
            </v-col>
            <v-col
              class="pa-1"
              cols="12"
              sm="6"
              :md="user.CodRole === 3 ? '3' : '6'"
            >
              <v-row justify="end" align="center">
                <v-btn
                  :disabled="loadingRelatorio"
                  style="color: white; border-radius: 8px"
                  color="green darken-1"
                  @click="geraRelatorio"
                >
                  <span style="font-size: 16px; font-weight: 500">Gerar</span>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <div class="clearfix" />
          <v-card color="#28416a" class="white--text">
            <v-card-title primary-title>
              <v-row
                v-if="loadingRelatorio"
                class="fill-height ma-2 flex-column"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  style="margin-bottom: 8px"
                  :size="80"
                  color="white"
                  indeterminate
                />
                <span style="font-size: 18px">Obtendo relatório...</span>
              </v-row>
              <div
                v-else-if="relatorio"
                class="d-flex flex-column"
                style="margin: 12px 0px; width: 100%"
              >
                <div
                  class="d-flex flex-column flex-md-row justify-md-space-between align-md-center"
                >
                  <div>
                    <span style="font-size: 22px; font-weight: 500">
                      Relatório de fazendas
                    </span>
                    <br />
                    <span style="font-size: 16px; font-weight: 400"
                      ><strong>Período:</strong>
                      {{
                        moment(dataInicio).format('DD/MM/YYYY') +
                        ' à ' +
                        moment(dataFim).format('DD/MM/YYYY')
                      }}</span
                    >
                    <br />
                    <span style="font-size: 16px; font-weight: 400">
                      <strong>Número de fazendas:</strong>
                      {{ relatorio.length }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <v-btn
                      :loading="loadingBtnPDF"
                      icon
                      large
                      color="white"
                      title="Exportar PDF"
                      @click="exportPDF"
                    >
                      <v-icon>mdi-file-pdf</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      large
                      color="white"
                      title="Exportar EXCEL"
                      @click="exportExcel"
                    >
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div>
                  <v-row>
                    <v-col cols="12" sm="6" lg="4">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        color="teal"
                        label="Pesquisar"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        clear-icon="mdi-close"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-else style="margin: 12px 0px">
                <span style="font-weight: 400">{{
                  user.CodRole === 3
                    ? 'Selecione uma agroindústria e determine o período que você deseja gerar o relatório de fazendas.'
                    : 'Determine o período que você deseja gerar o relatório de fazendas.'
                }}</span>
              </div>
            </v-card-title>
          </v-card>
        </div>
        <div v-if="!loadingRelatorio && relatorio">
          <v-row v-if="relatorio.length">
            <v-col cols="12" xl="7">
              <GmapMap
                ref="mapRef"
                :center="{lat: posLat, lng: posLng}"
                :zoom="8"
                map-type-id="hybrid"
                :options="{
                  zoomControl: false,
                  mapTypeControl: true,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                }"
                class="map-radius"
                style="height: 550px"
              >
                <GmapInfoWindow
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen = false"
                />
                <GmapMarker
                  v-for="(f, index) in fazendas"
                  :key="index"
                  :position="{
                    lat: parseFloat(f.Latitude),
                    lng: parseFloat(f.Longitude),
                  }"
                  :clickable="true"
                  :draggable="false"
                  @click="toggleInfoWindow(f, index)"
                />
              </GmapMap>
            </v-col>
            <v-col cols="12" xl="5">
              <g-chart
                type="PieChart"
                :data="chartData"
                :options="chartOptions"
                style="width: 100%; height: 550px"
              />
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="relatorio"
            :search="search"
            no-results-text="Nenhum resultado para o texto pesquisado"
            item-key="id_resposta"
            calculate-widths
            fixed-header
            class="elevation-1 diretor-table mt-2"
          >
            <template v-slot:[`item.consultor`]="{item}">
              {{ item.consultor ? item.consultor.nome : ' - ' }}
            </template>
            <template v-slot:[`item.latitude`]="{item}">
              {{ item.latitude || ' - ' }}
            </template>
            <template v-slot:[`item.longitude`]="{item}">
              {{ item.longitude || ' - ' }}
            </template>
            <template v-slot:[`item.dataFinalizacao`]="{item}">
              {{ moment(item.dataFinalizacao).format('DD/MM/YYYY HH:mm') }}
            </template>
            <template v-slot:no-data>
              <v-alert
                :value="noData"
                color="yellow darken-4"
                icon="mdi-alert-circle-outline"
              >
                Nenhuma fazenda consultada durante o período selecionado.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import relatorio from '@/services/RelatorioPDF.js'

export default {
  data() {
    return {
      agroindustria: [],
      diagnostico: null,
      dataLimite: this.moment().toISOString(true).substr(0, 10),
      dataInicio: this.moment()
        .subtract(1, 'months')
        .toISOString(true)
        .substr(0, 10),
      dataFim: this.moment().toISOString(true).substr(0, 10),
      menuDataIni: false,
      menuDataFim: false,
      noData: false,
      loadingRelatorio: false,
      loadingDiagnostico: false,
      loadingBtnPDF: false,
      dialogDiagnostico: false,
      agroindustrias: [],
      loading: true,
      relatorio: null,
      search: null,
      headers: [
        {
          align: 'left',
          sortable: true,
          text: 'Fazenda',
          value: 'fazenda.resposta',
          width: '200px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Consultor',
          value: 'consultor.nome',
          width: '250px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Cidade',
          value: 'cidade',
          width: '180px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Latitude',
          value: 'latitude',
          width: '120px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Longitude',
          value: 'longitude',
          width: '120px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Data - Hora',
          value: 'dataFinalizacao',
          width: '160px',
        },
      ],
      fazendas: [],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      chartOptions: {
        colors: ['#1E88E0', '#D32F20'],
        legend: {
          position: 'bottom',
        },
      },
      posLat: 0,
      posLng: 0,
    }
  },
  computed: {
    ...mapState({survey: state => state.survey, user: state => state.user}),
  },
  mounted() {
    if (this.user.CodRole === 3) {
      this.getAgroindustrias()
    } else {
      this.loading = false
    }
  },
  methods: {
    geraRelatorio() {
      if (this.user.CodRole === 3 && !this.agroindustria) {
        this.Swal.fire('', 'Selecione uma agroindústria.', 'error')
      } else {
        this.loadingRelatorio = true
        this.api
          .get('relatorio/fazendas', {
            params: {
              cnpj:
                this.user.CodRole === 3
                  ? this.agroindustria.map(el => el.cnpj)
                  : [this.user.agroindustria.cnpj],
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
            },
          })
          .then(response => {
            this.relatorio = response.data
            this.fazendas = []
            if (this.relatorio.length) {
              let latMedia = 0
              let lngMedia = 0
              this.relatorio.forEach(el => {
                if (el.latitude) {
                  this.fazendas.push({
                    Latitude: el.latitude,
                    Longitude: el.longitude,
                    infoText:
                      '<span style="font-weight: 600; font-size: 18px">' +
                      el.fazenda.resposta +
                      '</span><span style="font-weight: 500; font-size: 14px"><br>Cidade: ' +
                      el.cidade +
                      '</span>' +
                      '</span><span style="font-weight: 500; font-size: 14px"><br>Consultor: ' +
                      el.consultor.nome +
                      '</span>' +
                      '</span><span style="font-weight: 500; font-size: 14px"><br>Data: ' +
                      this.moment(el.dataFinalizacao).format(
                        'DD/MM/YYYY HH:mm',
                      ) +
                      '</span>',
                  })
                  latMedia += parseFloat(el.latitude)
                  lngMedia += parseFloat(el.longitude)
                }
              })
              this.posLat = latMedia / this.fazendas.length
              this.posLng = lngMedia / this.fazendas.length
              this.chartData = [
                ['Georreferenciadas', 'Sem localização'],
                ['Georreferenciadas', this.fazendas.length],
                [
                  'Sem localização',
                  this.relatorio.length - this.fazendas.length,
                ],
              ]
            }
            this.noData = !this.relatorio.length
            this.loadingRelatorio = false
          })
      }
    },
    getAgroindustrias() {
      this.api.get('/agroindustria').then(response => {
        this.agroindustrias = response.data
        this.agroindustrias.forEach(el => {
          el.display_nome = el.Nome + ' - ' + el.cnpj
        })
        this.loading = false
      })
    },
    exportExcel() {
      const newArq = JSON.parse(
        JSON.stringify(
          this.relatorio.map(el => {
            return {
              fazenda: el.fazenda ? el.fazenda.resposta : ' - ',
              consultor: el.consultor ? el.consultor.nome : ' - ',
              cidade: el.cidade || ' - ',
              latitude: el.latitude || ' - ',
              longitude: el.longitude || ' - ',
              data: this.moment(el.dataFinalizacao).format('DD/MM/YYYY HH:mm'),
            }
          }),
        ),
      )
      const file = this.XLSX.utils.json_to_sheet(newArq, {
        header: [
          'fazenda',
          'consultor',
          'cidade',
          'latitude',
          'longitude',
          'data',
        ],
      })
      file['!cols'] = []
      file['!cols'][0] = {wpx: 250}
      file['!cols'][1] = {wpx: 200}
      file['!cols'][2] = {wpx: 250}
      file['!cols'][3] = {wpx: 200}
      file['!cols'][4] = {wpx: 200}
      file['!cols'][5] = {wpx: 200}
      file.A1.v = 'Fazenda'
      file.B1.v = 'Consultor'
      file.C1.v = 'Cidade'
      file.D1.v = 'Latitude'
      file.E1.v = 'Longitude'
      file.F1.v = 'Data - Hora'
      const wb = this.XLSX.utils.book_new()
      this.XLSX.utils.book_append_sheet(wb, file, 'file')
      if (this.user.CodRole === 3) {
        this.XLSX.writeFile(wb, 'relatorio_fazendas.xlsx')
      } else {
        this.XLSX.writeFile(
          wb,
          'fazendas_' +
            this.user.agroindustria.Nome.replace(/ /g, '-') +
            '.xlsx',
        )
      }
    },
    async exportPDF() {
      this.loadingBtnPDF = true
      const self = this
      const col = [
        'Fazenda',
        'Consultor',
        'Cidade',
        'Latitude',
        'Longitude',
        'Data - Hora',
      ]
      const rows = this.relatorio.map(function (data) {
        return [
          data.fazenda ? data.fazenda.resposta : ' - ',
          data.consultor ? data.consultor.nome : ' - ',
          data.cidade || ' - ',
          data.latitude || ' - ',
          data.longitude || ' - ',
          self.moment(data.dataFinalizacao).format('DD/MM/YYYY HH:mm'),
        ]
      })

      const informacoes = [
        'Agroindústria: ' +
          (this.user.CodRole === 3
            ? this.agroindustria.reduce(
                (acc, curr, index, arr) =>
                  acc +
                  curr.display_nome +
                  (arr.length - 1 === index ? '' : ', '),
                '',
              )
            : this.user.agroindustria.Nome),
        'Número de fazendas: ' + this.relatorio.length,
        'Período das consultas: ' +
          this.moment(this.dataInicio).format('DD/MM/YYYY') +
          ' à ' +
          this.moment(this.dataFim).format('DD/MM/YYYY'),
        'Data do relatório: ' + this.moment().format('DD/MM/YYYY'),
      ]
      Promise.resolve(
        relatorio.Tabela(
          col,
          rows,
          'Relatório de Fazendas',
          informacoes,
          'landscape',
        ),
      ).then(() => {
        this.loadingBtnPDF = false
      })
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = {
        lat: parseFloat(marker.Latitude),
        lng: parseFloat(marker.Longitude),
      }
      this.infoOptions.content = marker.infoText
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
  },
}
</script>
<style>
.Underline > .v-input__control > .v-input__slot:before {
  border-style: hidden;
}

.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-input__slot {
  font: 13.3px Roboto;
}

.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-text-field__slot
  input {
  color: black;
}
.v-input.positivo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: teal !important;
}
.v-input.negativo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: #f52b1b !important;
}
.list-diagnostico .v-list-item__title {
  font-weight: 400;
  color: #434343;
}
.list-diagnostico .v-list-item__subtitle {
  color: #28416a !important;
  font-weight: 500;
}
.map-radius .vue-map {
  border-radius: 20px;
}
</style>
